<template>
  <div>
    <a-modal
        v-model="visible"
        title="查看车辆信息"
        :footer="null"
        width="1200px"
        @cancel="handleCancel"
        class="modern-car-modal"
        :bodyStyle="{ padding: '24px', background: '#f8fafc' }"
        :maskClosable="false"
    >
      <div class="car-form-container">
        <!-- 基本信息卡片 -->
        <div class="form-card">
          <div class="card-header">
            <div class="card-title">
              <a-icon type="car" class="title-icon" />
              <span>基本信息</span>
            </div>
            <div class="card-subtitle">车辆基础信息和技术参数</div>
          </div>
          <div class="card-content">
            <a-row :gutter="[24, 16]">
              <!-- 第一行：核心信息 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车牌号</label>
                  <a-input
                      :value="form.plateNumber"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆类型</label>
                  <a-input
                      :value="form.vehicleType"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆品牌</label>
                  <a-input
                      :value="form.vehicleBrand"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>

              <!-- 第二行：识别信息 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆识别代码</label>
                  <a-input
                      :value="form.vehicleIdentificationNumber"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">发动机号</label>
                  <a-input
                      :value="form.engineNumber"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">燃料类型</label>
                  <a-input
                      :value="form.fuelType"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>

              <!-- 第三行：技术参数 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">额定百公里油耗(L/KM)</label>
                  <a-input
                      :value="form.fuelConsumption"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆颜色</label>
                  <a-input
                      :value="form.vehicleColor"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆状态</label>
                  <a-input
                      :value="formatVehicleStatus(form.vehicleStatus)"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>

              <!-- 第四行：载重信息 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">核定载质量(吨)</label>
                  <a-input
                      :value="form.maxLoad"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">载货容积(m³)</label>
                  <a-input
                      :value="form.volume"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆附件</label>
                  <div v-if="vehicleAnnexList.length">
                    <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                      <img
                          v-for="(file, idx) in vehicleAnnexList"
                          :key="idx"
                          v-show="isImage(file)"
                          :src="getFileUrl(file)"
                          alt="附件"
                          style="width: 48px; height: 48px; object-fit: cover; border-radius: 4px; border: 1.5px solid #eee; cursor: pointer;"
                          @click="showPreview(getFileUrl(file))"
                      />
                    </div>
                  </div>
                  <div v-else style="color: #bbb;">无附件</div>
                </div>
              </a-col>

              <!-- 第五行：备注 -->
              <a-col :span="24" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">备注</label>
                  <a-textarea
                      :value="form.remarks"
                      :rows="3"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
            </a-row>
          </div>
        </div>

        <!-- 档案信息卡片 -->
        <div class="form-card">
          <div class="card-header">
            <div class="card-title">
              <a-icon type="folder" class="title-icon" />
              <span>档案信息</span>
            </div>
            <div class="card-subtitle">车辆档案管理和证件信息</div>
          </div>
          <div class="card-content">
            <a-row :gutter="[24, 16]">
              <!-- 第一行：基础档案 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆编号</label>
                  <a-input
                      :value="form.vehicleNumber"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车主姓名</label>
                  <a-input
                      :value="form.carOwner"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车主手机号</label>
                  <a-input
                      :value="form.carOwnerPhone"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>

              <!-- 第二行：日期信息 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆上户日期</label>
                  <a-input
                      :value="formatDate(form.vehicleRegistrationTime)"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆入公司日期</label>
                  <a-input
                      :value="formatDate(form.registrationDate)"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">车辆期初公里数</label>
                  <a-input
                      :value="form.vehicleInitialMileage"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
            </a-row>
          </div>
        </div>

        <!-- 证件信息卡片 -->
        <div class="form-card">
          <div class="card-header">
            <div class="card-title">
              <a-icon type="safety-certificate" class="title-icon" />
              <span>证件信息</span>
            </div>
            <div class="card-subtitle">行驶证、保险等证件管理</div>
          </div>
          <div class="card-content">
            <a-row :gutter="[24, 16]">
              <!-- 第一行：行驶证信息 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">行驶证号</label>
                  <a-input
                      :value="form.drivingPermitNumber"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">行驶证到期时间</label>
                  <a-input
                      :value="formatDate(form.drivingPermitExpireTime)"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">商业险到期时间</label>
                  <a-input
                      :value="formatDate(form.insuranceExpireTime)"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>

              <!-- 第二行：保险信息 -->
              <a-col :span="8" class="ant-col-customize-input">
                <div class="form-item">
                  <label class="form-label">交强险到期时间</label>
                  <a-input
                      :value="formatDate(form.compulsoryInsuranceExpireTime)"
                      disabled
                      size="large"
                  />
                </div>
              </a-col>
<!--              <a-col :span="8" class="ant-col-customize-input">-->
<!--                <div class="form-item">-->
<!--                  <label class="form-label">GPS开始时间</label>-->
<!--                  <a-input-->
<!--                      :value="formatDate(form.gpsStartTime)"-->
<!--                      disabled-->
<!--                      size="large"-->
<!--                  />-->
<!--                </div>-->
<!--              </a-col>-->
<!--              <a-col :span="8" class="ant-col-customize-input">-->
<!--                <div class="form-item">-->
<!--                  <label class="form-label">GPS结束时间</label>-->
<!--                  <a-input-->
<!--                      :value="formatDate(form.gpsEndTime)"-->
<!--                      disabled-->
<!--                      size="large"-->
<!--                  />-->
<!--                </div>-->
<!--              </a-col>-->
            </a-row>
          </div>
        </div>

        <!-- 附件信息卡片 -->
        <div class="form-card">
          <div class="card-header">
            <div class="card-title">
              <a-icon type="paper-clip" class="title-icon" />
              <span>附件管理</span>
            </div>
            <div class="card-subtitle">相关证件和文档</div>
          </div>
          <div class="card-content">
            <a-row :gutter="[24, 24]">
              <!-- 行驶证附件 -->
              <a-col :span="8">
                <div class="attachment-section">
                  <div class="attachment-title">
                    <a-icon type="file-text" />
                    行驶证附件
                  </div>
                  <div v-if="drivingPermitAnnexList.length">
                    <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                      <img
                          v-for="(file, idx) in drivingPermitAnnexList"
                          :key="idx"
                          v-show="isImage(file)"
                          :src="getFileUrl(file)"
                          alt="附件"
                          style="width: 48px; height: 48px; object-fit: cover; border-radius: 4px; border: 1.5px solid #eee; cursor: pointer;"
                          @click="showPreview(getFileUrl(file))"
                      />
                    </div>
                  </div>
                  <div v-else style="color: #bbb;">无附件</div>
                </div>
              </a-col>

              <!-- 运营证附件 -->
              <a-col :span="8">
                <div class="attachment-section">
                  <div class="attachment-title">
                    <a-icon type="file-text" />
                    运营证附件
                  </div>
                  <div v-if="tradingCardAnnexList.length">
                    <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                      <img
                          v-for="(file, idx) in tradingCardAnnexList"
                          :key="idx"
                          v-show="isImage(file)"
                          :src="getFileUrl(file)"
                          alt="附件"
                          style="width: 48px; height: 48px; object-fit: cover; border-radius: 4px; border: 1.5px solid #eee; cursor: pointer;"
                          @click="showPreview(getFileUrl(file))"
                      />
                    </div>
                  </div>
                  <div v-else style="color: #bbb;">无附件</div>
                </div>
              </a-col>

              <!-- 产权证附件 -->
              <a-col :span="8">
                <div class="attachment-section">
                  <div class="attachment-title">
                    <a-icon type="file-text" />
                    产权证附件
                  </div>
                  <div v-if="vehicleCertificateAnnexList.length">
                    <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                      <img
                          v-for="(file, idx) in vehicleCertificateAnnexList"
                          :key="idx"
                          v-show="isImage(file)"
                          :src="getFileUrl(file)"
                          alt="附件"
                          style="width: 48px; height: 48px; object-fit: cover; border-radius: 4px; border: 1.5px solid #eee; cursor: pointer;"
                          @click="showPreview(getFileUrl(file))"
                      />
                    </div>
                  </div>
                  <div v-else style="color: #bbb;">无附件</div>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="form-actions">
          <a-button @click="handleCancel" size="large" class="cancel-btn">
            关闭
          </a-button>
        </div>
      </div>
    </a-modal>
    <!-- 图片预览组件 -->
    <ImagePreview
        :visible="previewVisible"
        :imageUrl="currentImageUrl"
        :alt="currentImageAlt"
        @close="handlePreviewClose"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import ImagePreview from '@/components/file/ImagePreview.vue'
export default {
  name: "CarViewModal",
  components: {ImagePreview},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      previewVisible: false,
      currentImageUrl: '',
      currentImageAlt: ''
    }
  },
  computed: {
    vehicleAnnexList() {
      if (!this.form.vehicleAnnex) return [];
      if (Array.isArray(this.form.vehicleAnnex)) return this.form.vehicleAnnex;
      try {
        const arr = JSON.parse(this.form.vehicleAnnex);
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    },
    drivingPermitAnnexList() {
      if (!this.form.drivingPermitAnnex) return [];
      if (Array.isArray(this.form.drivingPermitAnnex)) return this.form.drivingPermitAnnex;
      try {
        const arr = JSON.parse(this.form.drivingPermitAnnex);
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    },
    tradingCardAnnexList() {
      if (!this.form.tradingCardAnnex) return [];
      if (Array.isArray(this.form.tradingCardAnnex)) return this.form.tradingCardAnnex;
      try {
        const arr = JSON.parse(this.form.tradingCardAnnex);
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    },
    vehicleCertificateAnnexList() {
      if (!this.form.vehicleCertificateAnnex) return [];
      if (Array.isArray(this.form.vehicleCertificateAnnex)) return this.form.vehicleCertificateAnnex;
      try {
        const arr = JSON.parse(this.form.vehicleCertificateAnnex);
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    },

  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
    },
    formatDate(val) {
      if (!val) return '';
      return dayjs(val).format('YYYY-MM-DD');
    },
    formatVehicleCertificateLocation(val) {
      if (val === '1' || val === 1) return '是';
      if (val === '0' || val === 0) return '否';
      return '';
    },
    formatVehicleStatus(val) {
      if (!val) return '';
      const statusMap = {
        'active': '使用中',
        'inactive': '停用',
        'maintenance': '维修中',
        'scrapped': '报废'
      };
      return statusMap[val] || val;
    },
    isImage(file) {
      const url = this.getFileUrl(file);
      if (!url) return false;
      return /\.(jpg|jpeg|png|gif)$/i.test(url);
    },
    getFileName(file) {
      const url = this.getFileUrl(file);
      if (!url) return '';
      return url.split('/').pop();
    },
    getFileUrl(file) {
      if (typeof file === 'string') return file;
      if (file && file.url) return file.url;
      return '';
    },
    showPreview(url) {
      this.currentImageUrl = url;
      this.currentImageAlt = '图片预览';
      this.previewVisible = true;
    },
    handlePreviewClose() {
      this.previewVisible = false;
      this.currentImageUrl = '';
      this.currentImageAlt = '';
    },

  }
}
</script>

<style scoped>
/* 主容器样式 */
.modern-car-modal {
  z-index: 1000;
}

.modern-car-modal .ant-modal-content {
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.modern-car-modal .ant-modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-bottom: none;
  padding: 20px 24px;
}

.modern-car-modal .ant-modal-title {
  color: white;
  font-size: 18px;
  font-weight: 600;
}

.modern-car-modal .ant-modal-close {
  color: white;
  top: 20px;
  right: 20px;
}

.modern-car-modal .ant-modal-close:hover {
  color: rgba(255, 255, 255, 0.8);
}

/* 表单容器 */
.car-form-container {
  padding: 0;
}

/* 卡片样式 */
.form-card {
  background: white;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
  overflow: hidden;
  transition: all 0.3s ease;
}

.form-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.card-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
}

.card-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 4px;
}

.title-icon {
  margin-right: 8px;
  color: #667eea;
  font-size: 18px;
}

.card-subtitle {
  color: #64748b;
  font-size: 13px;
  margin: 0;
}

.card-content {
  padding: 24px;
}

/* 表单项样式 */
.form-item {
  margin-bottom: 0;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #374151;
  font-size: 14px;
  line-height: 1.4;
}

/* 输入框样式 */
.ant-col-customize-input .ant-input,
.ant-col-customize-input .ant-input-disabled,
.ant-col-customize-input .ant-select-selection,
.ant-col-customize-input .ant-calendar-picker-input,
.ant-col-customize-input .ant-input-number,
.ant-col-customize-input .ant-textarea-disabled {
  border-radius: 8px;
  border: 1.5px solid #e2e8f0;
  background-color: #f8fafc;
  color: #4a5568;
  font-size: 14px;
  transition: all 0.3s ease;
}

.ant-col-customize-input .ant-input:hover,
.ant-col-customize-input .ant-select-selection:hover,
.ant-col-customize-input .ant-calendar-picker-input:hover,
.ant-col-customize-input .ant-input-number:hover {
  border-color: #cbd5e0;
}

.ant-col-customize-input .ant-input:focus,
.ant-col-customize-input .ant-select-focused .ant-select-selection,
.ant-col-customize-input .ant-calendar-picker-focused .ant-calendar-picker-input,
.ant-col-customize-input .ant-input-number-focused {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* 附件区域样式 */
.attachment-section {
  background: #f8fafc;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e2e8f0;
}

.attachment-title {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #374151;
  margin-bottom: 12px;
  font-size: 14px;
}

.attachment-title .anticon {
  margin-right: 6px;
  color: #667eea;
}

/* 操作按钮 */
.form-actions {
  text-align: center;
  padding: 24px 0 0;
  border-top: 1px solid #e2e8f0;
  margin-top: 8px;
}

.cancel-btn {
  min-width: 120px;
  height: 40px;
  border-radius: 8px;
  border: 1.5px solid #e2e8f0;
  background: white;
  color: #64748b;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  border-color: #cbd5e0;
  color: #374151;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .modern-car-modal {
    width: 95% !important;
    max-width: 1000px;
  }

  .card-content {
    padding: 20px;
  }

  .ant-col-customize-input {
    margin-bottom: 16px;
  }
}

@media (max-width: 768px) {
  .modern-car-modal .ant-modal-header {
    padding: 16px 20px;
  }

  .modern-car-modal .ant-modal-title {
    font-size: 16px;
  }

  .card-header {
    padding: 16px 20px;
  }

  .card-title {
    font-size: 15px;
  }

  .card-content {
    padding: 16px;
  }

  .form-actions {
    padding: 16px 0 0;
  }

  .ant-col-customize-input {
    margin-bottom: 12px;
  }

  .attachment-section {
    padding: 12px;
  }
}
</style>

